// @ts-nocheck

import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import SubscribersTable from "./subscribers/SubscribersTable";
import AddSubscriberModal from "./subscribers/AddSubscriberModal";

const CommunicationSubscribersTab: React.FC = () => {
  const [activeRole, setActiveRole] = useState("athlete");
  const [showAddModal, setShowAddModal] = useState(false);

  const roleOptions = [
    { value: "athlete", label: "Athletes" },
    { value: "parent", label: "Parents" },
    { value: "college_coach", label: "College Coaches" },
    
    { value: "club_coach", label: "Club Coaches" },
    { value: "press", label: "Press" },
    { value: "vendor", label: "Vendors" },
    { value: "admin", label: "Admins" },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Email Subscribers</h2>
          <p className="text-muted-foreground">
            Manage email subscribers across all member types
          </p>
        </div>
        <Button onClick={() => setShowAddModal(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Add Subscriber
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Subscribers by Role</CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs value={activeRole} onValueChange={setActiveRole} className="space-y-4">
            <TabsList className="grid w-full grid-cols-4 lg:grid-cols-8">
              {roleOptions.map((role) => (
                <TabsTrigger key={role.value} value={role.value} className="text-xs">
                  {role.label}
                </TabsTrigger>
              ))}
            </TabsList>

            {roleOptions.map((role) => (
              <TabsContent key={role.value} value={role.value} className="space-y-4">
                <SubscribersTable roleSlug={role.value} />
              </TabsContent>
            ))}
          </Tabs>
        </CardContent>
      </Card>

      <AddSubscriberModal 
        open={showAddModal} 
        onClose={() => setShowAddModal(false)}
        defaultRole={activeRole}
      />
    </div>
  );
};

export default CommunicationSubscribersTab;
